<footer class="footer">

  <section class="footer__primary">

    <div class="info">

      <img src="/assets/images/logo-footer.webp"
        alt="Carlton Farms logo featuring silhouettes of a cow, pig, and chicken on a red background. Text reads: 'Carlton Farms, Rockmart, GA, Est. 1919, Pasture-Raised Meat, Milk & Eggs.">

      <div class="data">
        <a href="mailto:info@carltonfarm.com">
          <i class="material-symbols-outlined">
            mail
          </i> {{'info@carltonfarm.com'}}
        </a>
        <a href="tel: 7706551503">
          <i class="material-symbols-outlined">
            call
          </i> 770-655-1503
        </a>
        <span>
          <i class="material-symbols-outlined">
            location_on
          </i> 1276 Cartersville Hwy., Rockmart, GA 30153
        </span>
      </div>

    </div>

    <div class="menu">

      @for (x of menu(); track $index) {
      <div class="column">
        <span class="header">
          {{x.header}}
        </span>
        @for (y of x.items; track $index) {
        @if (y.show()) {
        <span class="item" [routerLink]="y.link">
          {{y.text}}
        </span>
        }
        }
      </div>
      }

      <div class="to-top-button">
        <div class="to-top" (click)="scrollToTop()">
          <span class="material-symbols-outlined">
            expand_circle_up
          </span>
          <small>To top</small>
        </div>
      </div>

    </div>

  </section>

  <hr>

  <section class="footer__secondary">

    <span>
      Carlton Farms © {{copyRightYear}}. All Rights Reserved.
    </span>

    <span>
      Powered by: <a href="https://navego.tech" [target]="'_blank'" class="link-navego">Navego</a>
    </span>

    <div class="icons">

      <a href="https://www.facebook.com/carltonfarm/" target="_blank" rel="noopener" aria-label="Facebook link"
        class="icon">
        <svg width="12" height="22" viewBox="0 0 12 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.3037 1.07312V4.31419H9.37622C8.67235 4.31419 8.19765 4.46151 7.95211 4.75616C7.70658 5.0508 7.58381 5.49276 7.58381 6.08205V8.40236H11.1809L10.7021 12.0363H7.58381V21.3544H3.82711V12.0363H0.696533V8.40236H3.82711V5.72602C3.82711 4.2037 4.25271 3.02308 5.1039 2.18417C5.95509 1.34526 7.08865 0.925798 8.50457 0.925798C9.70769 0.925798 10.6407 0.974907 11.3037 1.07312Z"
            fill="white" />
        </svg>
      </a>

      <a href="https://twitter.com/carltonfarm" target="_blank" rel="noopener" aria-label="Twitter link" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
          <path
            d="M18.42,14.009L27.891,3h-2.244l-8.224,9.559L10.855,3H3.28l9.932,14.455L3.28,29h2.244l8.684-10.095,6.936,10.095h7.576l-10.301-14.991h0Zm-3.074,3.573l-1.006-1.439L6.333,4.69h3.447l6.462,9.243,1.006,1.439,8.4,12.015h-3.447l-6.854-9.804h0Z">
          </path>
        </svg>
      </a>

      <a href="https://www.instagram.com/carltonfarm/?hl=en" target="_blank" rel="noopener" aria-label="Instagram link"
        class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor">
          <path
            d="M10.202,2.098c-1.49,.07-2.507,.308-3.396,.657-.92,.359-1.7,.84-2.477,1.619-.776,.779-1.254,1.56-1.61,2.481-.345,.891-.578,1.909-.644,3.4-.066,1.49-.08,1.97-.073,5.771s.024,4.278,.096,5.772c.071,1.489,.308,2.506,.657,3.396,.359,.92,.84,1.7,1.619,2.477,.779,.776,1.559,1.253,2.483,1.61,.89,.344,1.909,.579,3.399,.644,1.49,.065,1.97,.08,5.771,.073,3.801-.007,4.279-.024,5.773-.095s2.505-.309,3.395-.657c.92-.36,1.701-.84,2.477-1.62s1.254-1.561,1.609-2.483c.345-.89,.579-1.909,.644-3.398,.065-1.494,.081-1.971,.073-5.773s-.024-4.278-.095-5.771-.308-2.507-.657-3.397c-.36-.92-.84-1.7-1.619-2.477s-1.561-1.254-2.483-1.609c-.891-.345-1.909-.58-3.399-.644s-1.97-.081-5.772-.074-4.278,.024-5.771,.096m.164,25.309c-1.365-.059-2.106-.286-2.6-.476-.654-.252-1.12-.557-1.612-1.044s-.795-.955-1.05-1.608c-.192-.494-.423-1.234-.487-2.599-.069-1.475-.084-1.918-.092-5.656s.006-4.18,.071-5.656c.058-1.364,.286-2.106,.476-2.6,.252-.655,.556-1.12,1.044-1.612s.955-.795,1.608-1.05c.493-.193,1.234-.422,2.598-.487,1.476-.07,1.919-.084,5.656-.092,3.737-.008,4.181,.006,5.658,.071,1.364,.059,2.106,.285,2.599,.476,.654,.252,1.12,.555,1.612,1.044s.795,.954,1.051,1.609c.193,.492,.422,1.232,.486,2.597,.07,1.476,.086,1.919,.093,5.656,.007,3.737-.006,4.181-.071,5.656-.06,1.365-.286,2.106-.476,2.601-.252,.654-.556,1.12-1.045,1.612s-.955,.795-1.608,1.05c-.493,.192-1.234,.422-2.597,.487-1.476,.069-1.919,.084-5.657,.092s-4.18-.007-5.656-.071M21.779,8.517c.002,.928,.755,1.679,1.683,1.677s1.679-.755,1.677-1.683c-.002-.928-.755-1.679-1.683-1.677,0,0,0,0,0,0-.928,.002-1.678,.755-1.677,1.683m-12.967,7.496c.008,3.97,3.232,7.182,7.202,7.174s7.183-3.232,7.176-7.202c-.008-3.97-3.233-7.183-7.203-7.175s-7.182,3.233-7.174,7.203m2.522-.005c-.005-2.577,2.08-4.671,4.658-4.676,2.577-.005,4.671,2.08,4.676,4.658,.005,2.577-2.08,4.671-4.658,4.676-2.577,.005-4.671-2.079-4.676-4.656h0">
          </path>
        </svg>
      </a>

    </div>

  </section>

  <!-- To top -->
  <div class="to-top mobile" (click)="scrollToTop()">
    <span class="material-symbols-outlined">
      expand_circle_up
    </span>
    <small>To top</small>
  </div>

</footer>